import Vue from 'vue'
import App from './App.vue'
import { createRouter } from './router'
import { createStore } from './store'
import { sync } from 'vuex-router-sync'

export function createApp () {
  const router = createRouter()
  const store = createStore()

  sync(store, router)

  Vue.config.productionTip = false
  Vue.config.devtools = process.env.NODE_ENV !== 'production'

  const app = new Vue({
    router: router,
    store: store,
    render: function (createElement) {
      return createElement(App)
    }
  })

  return { app: app, router: router, store: store }
}
